import Vue from 'vue';

const bandeirasCartoes = {
    amex: /^3[47][0-9]{13}/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    visa: /^4[0-9]{12}(?:[0-9]{3})/,
    master: /^5[1-5][0-9]{14}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/
  }

Vue.directive('card', {
    componentUpdated (el, binding, vnode) {
      const value = el.value.replace(/\s/g, '')
      if (bandeirasCartoes['amex'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_amex.svg')
      } else if (bandeirasCartoes['diners'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_vazio.png')
      } else if (bandeirasCartoes['master'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_master.svg')
      } else if (bandeirasCartoes['visa'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_visa.svg')
      } else if (bandeirasCartoes['elo'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_vazio.png')
      } else if (bandeirasCartoes['jcb'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_jcb.svg')
      } else if (bandeirasCartoes['discover'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_discover.svg')
      } else if (bandeirasCartoes['hipercard'].test(value)) {
        vnode.context.bandeira = require('@/assets/images/cartao_vazio.png')
      } else {
        vnode.context.bandeira = require('@/assets/images/cartao_vazio.png')
      }
    }
  });

 export default this
